import React from 'react'
import { Word } from '../models/Word';
import { IonIcon, IonLabel, IonCard, IonCardHeader, IonCardTitle, IonCardSubtitle, IonCardContent, IonRow, IonGrid } from '@ionic/react';
import { thumbsUp, thumbsDown } from 'ionicons/icons';

interface Props {
    word: Word,
    onClick: () => any
}

const ItemWordSearch: React.FC<Props> = (props: Props) => {
  return (
    <IonCard type="button" className="cursor" onClick={() => props.onClick()}>
      <IonCardHeader>
        <IonCardTitle>{props.word.text}</IonCardTitle>
        <IonCardSubtitle>{props.word.state}</IonCardSubtitle>
      </IonCardHeader>
      <IonCardContent>
        <IonGrid className="ion-justify-content-start ion-align-self-center">
          <IonRow>
            <IonRow className="ion-col ion-align-self-center ion-padding-end">
              <IonIcon icon={thumbsUp} color="secondary" size="small"> {props.word.votes.up} </IonIcon>
              <IonLabel>({props.word.votes.up})</IonLabel>
            </IonRow>
            <IonRow className="ion-col ion-align-self-center ion-padding-end">
              <IonIcon icon={thumbsDown} color="danger" size="small"> {props.word.votes.down} </IonIcon>
              <IonLabel>({props.word.votes.down})</IonLabel>
            </IonRow>
          </IonRow>
        </IonGrid>
      </IonCardContent>
    </IonCard>
  )
}

export default ItemWordSearch;
